import { Component, OnInit, Input, ChangeDetectorRef, ViewChild } from '@angular/core';

import { DropzoneConfigInterface } from 'ngx-dropzone-wrapper';
import { Alert, Support } from '@app/models';
import { SupportService } from '@app/services';

import Swal from 'sweetalert2';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-chat-support',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.scss']
})
export class ChatSupportComponent implements OnInit {
  toast = new Alert();
  
  @ViewChild('scrollMe') scrollMe;
  @Input() action: string;
  @Input() me: boolean;
  @Input() friend: boolean;
  @Input() src_id: number;
  @Input() dest_id: number;
  @Input() messages: Support[];
  @ViewChild("messageContent") messageContent;

  newMessage: string = '';

  loading: boolean = false;
  submitted: any = null;

  //upload settings
  files: any[] = [];

  config: DropzoneConfigInterface = {
    transformFile: function transformFile(file, done) {
      if ((this.options.resizeWidth || this.options.resizeHeight) && file.type.match(/image.*/)) {
        return this.resizeImage(file, this.options.resizeWidth, this.options.resizeHeight, this.options.resizeMethod, done);
      } else {
        return done(file);
      }
    }
  };
  
  constructor(
    public translate: TranslateService,
    private supportService: SupportService,
    private toastr: ToastrService,
    private cdr: ChangeDetectorRef
  ) {}

  addMessage(newMessage) {
    if(newMessage != ""){
      this.submitted = true;
      this.scrollToEnd(this.scrollMe);
      this.cdr.detectChanges();
      let body = { 
        content: newMessage,
        src_id: this.src_id,//me
        dst_id: this.dest_id,
        author: this.me == true? 'me' : 'friend'
      };
      this.supportService.createSupport(body).subscribe(
        (res)=>{
          if(res){
            this.newMessage = '';
            this.messageContent.nativeElement.focus();
            this.scrollToEnd(this.scrollMe);
            this.cdr.detectChanges();

            //refresh supports
            this.loadSupports();
          }
        },
        (err)=>{
          Swal.fire({...this.toast, icon: 'error', title: this.translate.instant('Error'), html: err});
          this.submitted = null;
          this.loading = false;
        });
    }
  }

  // Messages non lus
  loadUnreadSupports(body) {
    this.supportService.getUnreadSupportsByDestinataire(body).subscribe(
        res => res
    );
  }

  // Upload: Added
  onAdded(event) {
    this.readFile(event)
    .then(
      fileContents => {
        let file = {
          'uuid': event.upload.uuid, 
          'filename': `${event.upload.uuid}.${this.getExtension(event.type)}`, 
          'dataURL': fileContents,
          'type': event.type, 
          'size': event.upload.total,
          'error': 'UPLOAD_ERR_OK'
        };
        this.files.push(file);
        const images = this.files;
    })
    .catch(
      error => {
        this.toastr.warning(this.translate.instant('Problem with uploaded files'), this.translate.instant('Error Upload'));
    });
  }

  // Upload: Removed
  onRemove(event) {
    this.files.splice(this.files.indexOf(event), 1);
    const files = this.files;
  }

  // Upload: process file upload
  private async readFile(file: File): Promise<string | ArrayBuffer> {
    return new Promise<string | ArrayBuffer>((resolve, reject) => {

      const reader = new FileReader();

      //téléchargement ok
      reader.onload = e => {
        return resolve((e.target as FileReader).result);
      };

      //erreur au téléchargement
      reader.onerror = e => {
        this.toastr.warning(this.translate.instant('FileReader failed on file') + ` ${file.name}.`, this.translate.instant('Error Upload'));
        return reject(null);
      };

      //Pas de fichier
      if (!file) {
        this.toastr.warning(this.translate.instant('No file to read'), this.translate.instant('Error Upload'));
        return reject(null);
      }

      reader.readAsDataURL(file);
    });
  }

  // Upload: Formatage de l'extension via l'url
  getExtension(filename) {
    let extension = filename.split("/");
    return extension[1];
  }

  // Chargement de la liste des supports
  loadSupports() {
    let body = { 
      dst_id: this.src_id//me
    };
    this.supportService.getSupportsById(body).subscribe(
      (res)=>{
        if(res){
          this.messages = res;

          //non lu
          this.loadUnreadSupports(body);

          this.scrollToEnd(this.scrollMe);
          this.cdr.detectChanges();
          this.loading = true;
          this.scrollToEnd(this.scrollMe);
          this.cdr.detectChanges();

          setTimeout(() => {
            this.loading = false;
            this.scrollToEnd(this.scrollMe);
            this.cdr.detectChanges();
            this.submitted = null;
            this.scrollToEnd(this.scrollMe);
            this.cdr.detectChanges();
          },1200);
        }
      },
      (err)=>{
        Swal.fire({...this.toast, icon: 'error', title: this.translate.instant('Error'), html: err});
        this.loading = false;
        this.submitted = null;
      });
  }

  scrollToEnd(scrollMe){
    if(scrollMe){
      return scrollMe.scrollHeight;
    }
  }

  ngOnInit(): void { 
    this.scrollToEnd(this.scrollMe);
    this.cdr.detectChanges();
  }
}